export default "__VITE_ASSET__Bb0FLFM9__"